import { createContext, FunctionComponent, ReactElement, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import Api from "src/Config";

export const AlertOverviewContext = createContext(null);

type Props = {
  children: ReactElement;
};

const AlertOverviewProvider: FunctionComponent<Props> = ({ children }) => {
  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["alert_overview"],
    staleTime: 30000,
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`tm/overview?checkType=alerts`);

      return data;
    },
  });

  const contextValue = useMemo(
    () => ({
      isLoading,
      data,
      error,
      isFetching,
    }),
    [isLoading, data, error, isFetching],
  );
  return (
    <AlertOverviewContext.Provider value={contextValue}>
      {children}
    </AlertOverviewContext.Provider>
  );
};

export default AlertOverviewProvider;
